<template>
    <v-content>
        <v-card class="elevation-1 rounded-4">
            <v-toolbar flat height="55px">
                <v-icon color="primary" class="mr-2">email</v-icon>
                <span class="primary--text dialog-title-text">Contact Us</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog">
                    <span class="primary--text dialog-title-text">X</span>
                </v-btn>
            </v-toolbar>
            <v-card-text class="text-xs-left">
                <div style="margin:0px 10px 0px 15px;">
                    <p>We value your feedback, inquiries, and suggestions. Please feel free to reach out to us using the following contact information:</p>
                    <b>Customer Support</b>
                    <p>If you have any questions, concerns, or need assistance, our dedicated customer support team is here to help. You can reach us by email during our business hours.</p>
                    <ul>
                        <li>Email: <b>support@sweldonow.ph</b></li>
                    </ul><br>
                    <b>Billing Inquiries</b>
                    <p>For any questions or issues related to billing, invoices, or payment methods, please contact our billing department:</p>
                    <ul>
                        <li>Email: <b>billing@sweldonow.ph</b></li>
                    </ul><br>
                    <b>Sales and Affiliate Partnership</b>
                    <p>For business-related inquiries, such as sales or becoming an affiliate partner, please get in touch with our sales team. We're excited to explore new opportunities with you:</p>
                    <ul>
                        <li>Email: <b>sales@sweldonow.ph</b></li>
                    </ul>
                </div>
            </v-card-text>
        </v-card>   
    </v-content>
</template>
<script>
export default {
    data() {
        return {}
    },
    components: {},
    methods: {
        closeDialog() {
            this.$emit('update:dialogContactUs', false)
        },
        OpenEmailWindow(url) {
            window.open(url, '_blank')
        },
    },
    computed: {},
    created() {}
}
</script>
<style scoped>
.link {
    text-decoration: underline;
    color:#1976D2;
    cursor:pointer;
}
.dialog-title-text {
    font-size: 18px;
    font-weight: 700;
    font-family: 'Inter', sans-serif !important;
}
</style>